import AppHeader from '../components/Common/AppHeader';
import AppFooter from '../components/Common/AppFooter';

const FullWidthLayout = (props) => {
  const { children, className, showHeader = true, showTryApp } = props;

  return (
    <div className={className}>
      <AppHeader showHeader={showHeader} />
      {children}
      <AppFooter showTryApp={showTryApp} />
    </div>
  );
};

export default FullWidthLayout;
